import { CATEGORY } from 'src/refactor/helpers/constants'
import * as yup from 'yup'

export const getSearchSchema = (category: CATEGORY) =>
  yup.object().shape({
    serviceLines:
      category === CATEGORY.FACILITY
        ? yup.string().nullable().required('Facility is required')
        : yup.string().nullable(),
    name: yup.string(),
    placeId: yup.string().nullable().required('Location is required'),
  })
